import { useState } from "react";
import { CattleCard } from "../components/site/Cards";
import { BREEDS, useGet, useSettings } from "../lib/api";

export const PageHero = ({ eyebrow, title, desc }) => (
  <section className="border-b bg-[var(--cream)]">
    <div className="fade-up mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <p className="eyebrow">{eyebrow}</p>
      <h1 className="mt-3 font-display text-4xl font-semibold text-[var(--forest-dark)] sm:text-5xl">{title}</h1>
      {desc && <p className="mt-4 max-w-2xl text-[var(--ink)]/70">{desc}</p>}
    </div>
  </section>
);

export const FilterChips = ({ options, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map(([val, label]) => (
      <button
        key={val}
        onClick={() => onChange(val)}
        className={`rounded-full border px-5 py-2 text-sm font-medium transition-colors ${value === val ? "border-[var(--forest)] bg-[var(--forest)] text-white" : "bg-white text-[var(--ink)]/70 hover:border-[var(--forest)] hover:text-[var(--forest)]"}`}
        data-testid={`${prefix}-${val || "semua"}`}
      >
        {label}
      </button>
    ))}
  </div>
);

export default function Katalog() {
  const [breed, setBreed] = useState("");
  const { data: s } = useSettings();
  const { data, isLoading } = useGet("cattle", "/cattle", { breed });
  return (
    <>
      <PageHero eyebrow="Katalog Sapi" title="Pilih Sapi Terbaik Anda" desc="Label warna menunjukkan status setiap sapi: hijau tersedia, kuning sudah dipesan, merah sudah terjual." />
      <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <FilterChips options={[["", "Semua Ras"], ...BREEDS.map((b) => [b, b])]} value={breed} onChange={setBreed} prefix="breed-filter" />
        {isLoading ? (
          <p className="mt-10 text-[var(--ink)]/60">Memuat katalog...</p>
        ) : data?.length ? (
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="cattle-grid">
            {data.map((c) => <CattleCard key={c.id} c={c} whatsapp={s?.whatsapp} />)}
          </div>
        ) : (
          <p className="mt-10 text-[var(--ink)]/60" data-testid="cattle-empty">Belum ada sapi untuk ras ini.</p>
        )}
      </section>
    </>
  );
}
